var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [
          _vm._v(_vm._s(_vm.$t("customer_transfers.title"))),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            class: {
              "ring-card__header-buttons": true,
              "disable-html": _vm.loading,
            },
          },
          [
            _c("RefreshButton", {
              nativeOn: {
                click: function ($event) {
                  return _vm.getCustomerTransfers()
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "card-content",
      },
      [
        _c(
          "el-table",
          {
            staticClass: "device-transfers-table",
            staticStyle: { width: "100%" },
            attrs: { data: _vm.customer_transfers, "max-height": "500" },
          },
          [
            _c("el-table-column", {
              attrs: { label: "Actions" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.id &&
                      scope.row.status.toLowerCase() == "in_progress"
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { slot: "reference", type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showDialog(scope.row)
                                    },
                                  },
                                  slot: "reference",
                                },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.tooltip,
                                        placement: "top-start",
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-delete" })]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Doorbot id" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.doorbot_id) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Mac Address" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.mac_address) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Product" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm.findProduct(scope.row).description
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Old Owner" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.old_owner_id) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "New Owner" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      parseInt(scope.row.new_owner_id) > 0 &&
                      scope.row.new_owner_id != null
                        ? _c("span", [_vm._v(_vm._s(scope.row.new_owner_id))])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Status" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " + _vm._s(scope.row.status) + "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Reason" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " + _vm._s(scope.row.reason) + "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Start Date" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("moment")(
                              scope.row.start_date,
                              "MM/DD/YYYY HH:mm Z"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "End Date" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("moment")(
                              scope.row.end_date,
                              "MM/DD/YYYY HH:mm Z"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.selectedRow.id !== undefined,
              title: "Canceling device transfer",
              width: "30%",
              "show-close": false,
              center: "",
            },
            on: {
              "update:visible": function ($event) {
                return _vm.$set(_vm.selectedRow, "id !== undefined", $event)
              },
            },
          },
          [
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "16px",
                  "word-break": "break-word",
                  "text-align": "initial",
                  color: "#606266",
                },
              },
              [
                _vm._v(
                  "\n        This transfer will be canceled. Id: " +
                    _vm._s(_vm.selectedRow.id) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "text-align": "right", margin: "0" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.hideDialog()
                      },
                    },
                  },
                  [_vm._v("\n          cancel\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      loading: _vm.loading,
                      type: "primary",
                      size: "mini",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.cancelTransfer(_vm.selectedRow.id)
                      },
                    },
                  },
                  [_vm._v("\n          confirm\n        ")]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }